import Vue from 'vue'
import App from './App.vue'
import store from './store'
import axios from 'axios'
import '@tmcz/tmcz-vue-ui/dist/tmcz-vue-ui.css'
import router from './router'
import lodash from 'lodash'

Vue.config.productionTip = false
Vue.prototype.$http = axios

new Vue({
  store,
  router,
  lodash,
  render: h => h(App)
}).$mount('#app')
